import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogProps,
  DialogTitle,
  Fab,
  Grid,
  Typography,
} from '@mui/material'
import { makeStyles } from '@mui/styles'

import i18n from '../../locales/i18n'
import PuiCloseButton from '../buttons/PuiCloseButton'

const useStyles = makeStyles(
  theme => ({
    paper: {
      width: 450,
      maxWidth: 450,
      [theme.breakpoints.down('sm')]: {
        width: 'calc(100% - 32px)',
      },
    },
    root: {
      backgroundColor: theme.colors.contentBackground,
      padding: theme.spacing(3),
    },
    paperScrollBody: {},
    dialogContentRoot: {
      padding: 0,
      '&:first-child': {
        paddingTop: 0,
      },
    },
    title: {
      color: theme.colors.primaryText,
      fontWeight: 500,
      fontSize: '2rem',
    },
    dialogTitle: {
      padding: theme.spacing(1.5, 5, 1.5, 2),
      borderBottom: theme.constants.tableBorder,
    },
    actions: {
      borderTop: theme.constants.tableBorder,
      justifyContent: 'flex-start',
    },
    button: {
      height: 40,
      minWidth: 150,
      marginRight: theme.spacing(2),
    },
  }),
  { name: 'ConfirmCloseDialog' },
)

export interface ConfirmCloseDialogProps extends DialogProps {
  readonly notOkLabel?: React.ReactNode
  readonly okLabel?: React.ReactNode
  readonly onClose?: () => void
  readonly onNotOk: () => void
  readonly onOk: () => void
}

const ConfirmCloseDialog = ({
  title: titleProp,
  onClose,
  onOk,
  onNotOk,
  okLabel: okLabelProp,
  notOkLabel: notOkLabelProp,
  ...rest
}: ConfirmCloseDialogProps) => {
  const classes = useStyles()
  const title =
    titleProp || i18n.t<string>('Dialogs:CONFIRM_CLOSE_DIALOG.TITLE')
  const okLabel = okLabelProp || i18n.t<string>('Common:SAVE_ACTION')
  const notOkLabel = notOkLabelProp || i18n.t<string>('Common:DO_NOT_SAVE')

  return (
    <Dialog
      aria-labelledby="confirm-close-dialog"
      classes={{
        paper: classes.paper,
        paperScrollBody: classes.paperScrollBody,
      }}
      scroll="body"
      onClose={onClose}
      {...rest}
    >
      <DialogTitle className={classes.dialogTitle} id="confirm-close-dialog">
        <Typography className={classes.title}>{title}</Typography>
      </DialogTitle>
      <PuiCloseButton onClick={onClose} />
      <DialogContent className={classes.dialogContentRoot}>
        <Grid container className={classes.root} justifyContent="center">
          <Fab
            className={classes.button}
            color="inherit"
            variant="extended"
            onClick={onOk}
          >
            {okLabel}
          </Fab>
          <Fab
            className={classes.button}
            color="primary"
            variant="extended"
            onClick={onNotOk}
          >
            {notOkLabel}
          </Fab>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmCloseDialog
